import React, { useState, useEffect } from 'react'
import SurveyComponent from 'pages/RMO/components/cancerTemplate/Template'
import defaultSurveyConfig from 'pages/RMO/components/cancerTemplateForm/template'

export default function CommonPrintComponent({
  data,
  json,
  pageName,
  componentName,
  unfilledPrint,
  hideDot
}: any) {

  const [jsonForPrint, setJsonForPrint] = useState<any>({})
  const [dataForPrint, setDataForPrint] = useState<any>({})

  useEffect(() => {
    const res = { ...json }
    res?.pages?.forEach((each: any) => {
      each?.elements?.forEach((element: any) => {
        if (Object?.keys(element)?.includes("elements") || Object?.keys(element)?.includes("templateElements")) {
          const key = Object?.keys(element)?.includes("elements") ? "elements" : "templateElements"
          element[`${key}`]?.forEach((ele: any) => {
            const type = ele?.type
            if (Object?.keys(ele)?.includes("elements") || Object?.keys(ele)?.includes("templateElements")) {
              const key = Object?.keys(ele)?.includes("elements") ? "elements" : "templateElements"
              ele[`${key}`]?.forEach((e: any) => {
                const type = e?.type
                if (pageName === "Forms") {
                  if (type === "comment") {
                    e["type"] = "expression"
                  }
                }
              })
            }
            else {
              if (pageName === "Forms") {
                if (type === "comment") {
                  ele["type"] = "expression"
                }
              }
            }
          })
        } else {
          const type = element?.type
          if (pageName === "Forms") {
            if (type === "comment") {
              element["type"] = "expression"
            }
          }
        }
      })
    })
    setJsonForPrint(res)
  }, [json])

  useEffect(() => {
    const temp = { ...data }
    Object.keys(temp)?.forEach((each: any) => {
      if (Array?.isArray(temp[each]) && temp[each]?.length > 0) {
        temp[each]?.forEach((ele: any) => {
          Object?.keys(ele)?.forEach((e: any) => {
            if (ele[`${e}`] === "other") {
              if (Object.keys(ele)?.includes(`${e}-Comment`)) {
                ele[`${e}`] = ele[`${e}-Comment`]
                delete ele[`${e}-Comment`]
              }
            }
          })
        })
      } else {
        if (temp[`${each}`] === "other") {
          if (Object.keys(temp)?.includes(`${each}-Comment`)) {
            temp[`${each}`] = temp[`${each}-Comment`]
            delete temp[`${each}-Comment`]
          }
        }
      }
    })
    setDataForPrint(temp)
  }, [data])

  return (
    <div>
      <SurveyComponent
        css={defaultSurveyConfig.defaultSurveyCSS}
        data={dataForPrint}
        json={jsonForPrint}
        onComplete={(survey: any) => {
          const data = survey.data
          /** Save to a database */
          /** Add to a spreadsheet, etc.... */
        }}
        hideDot={hideDot}
      />
    </div>
  )
}
